import { UseCollection } from "@/common/composition/use-collection";
import { ListResult } from "@/common/models";
import { gql2, formatInput } from "@/gql/lib";
import { CoordinateInputTier3, ItemFilter } from "@/gql/types";
import { fileParser } from "@/gql/file-parser";
import { UseCluster } from "./cluster/cluster.substate";
const union_if_cords_are_same_in_both_axis = (
  cords: CoordinateInputTier3[]
): CoordinateInputTier3[] => {
  /*  */
  return cords;
};

const get_files = gql2<
  { cursor: string; cords: CoordinateInputTier3[] },
  ListResult<any>
>("get_files", ({ cords, cursor }) => {
  const q: ItemFilter = {
    coordinates: union_if_cords_are_same_in_both_axis(cords),
    cursor,
  };
  return {
    query: `{ 
             #EXPORT
              items(filter:${formatInput(q)}){
                id
                cursor
                name
                subType
                category
                externalId
                clusterUID
                extendedProperties{
                  topic
                }
                labelHistory{
                  userId
                }
                archive{
                 archiveName
                 siblings
                }
                internalItems{
                  name
                }
                labels{
                  infoLabel {
                    id
                    name
                    type
                    concreteScore 
                    generation
                    confidence
                  }
                  ctxLabels {
                    id
                    name
                    type
                    labelType
                    labelCategory
                    generation
                    confidence
                  }
                  adhocLabels {
                    id
                    name
                  }
                  piis {
                    id
                    name
                    labelCategory
                  }
                }
                path
                sourceApplication
                sensitivity
                sensitivityLevel
                createdAt
                extendedData
              }
              #EXPORT_END
            }`,
    mapper: (res) => {
      res.items = res.items.filter((item: any) => item.labels?.infoLabel);
      return fileParser(res);
    },
  };
});

export const UseFilesCollection = (
  input: () => CoordinateInputTier3[],
  clusterUID?: string
) =>
  UseCollection<any, { cursor: string }>(async ({ cursor }) => {
    if (clusterUID) {
      const cluster = UseCluster(clusterUID, (time_frame: string) => {
        return input().map((d) => {
          return {
            ...d,
            z: {
              type: d.z.type,
              values: [time_frame],
            },
          };
        });
      });
      return await cluster.load_cluster_files();
    } else {
      return await get_files({ cursor, cords: input() });
    }
  });
